import React from 'react';

import { UclTheme } from '@rbilabs/universal-components';

import useProviders from '../../providers';

type Props = React.PropsWithChildren<{
  uclTheme: UclTheme;
  sanityAssets: any;
  onErrorBoundaryRequestReload: () => void;
}>;

export default function ReduceProviders({
  children,
  uclTheme,
  sanityAssets,
  onErrorBoundaryRequestReload,
}: Props) {
  const providers = useProviders({
    uclTheme,
    sanityAssets,
    onErrorBoundaryRequestReload,
  });

  return (
    <>
      {providers.reduceRight((acc, Comp) => {
        return <Comp>{acc}</Comp>;
      }, children)}
    </>
  );
}
